import { render, staticRenderFns } from "./MentoringRequestModal.vue?vue&type=template&id=0a1b9a6c&scoped=true&"
import script from "./MentoringRequestModal.vue?vue&type=script&lang=js&"
export * from "./MentoringRequestModal.vue?vue&type=script&lang=js&"
import style0 from "./MentoringRequestModal.vue?vue&type=style&index=0&id=0a1b9a6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1b9a6c",
  null
  
)

export default component.exports